import React from 'react';
import { Col, Container, Label, Row, Table } from 'reactstrap';
import data from "../../assets/data/Progress/hosapital.json";
import Apaexlinecolumn from './Charts/hospitalapaexlinecolumn';

const hospitalBreakdown = () => {
    const calculateColumnTotal = (columnName) => {
        return data.reduce((total, item) => total + (item[columnName] || 0), 0);
      };

    return (
        <div className="pt-5">
            <div className="pt-3">
                <Container>
                    <Row className="justify-content-center text-center progreport-content">
                        <Label className='title pb-3' >BREAKDOWN OF PATIENTS AIDED PER TYPE OF HOSPITAL</Label>
                        {/* <Col md={1} /> */}
                        {/* <Col  md={10}><img src={HospitalChart}  /></Col> */}
                        <Col  md={12}>
                            <Row>
                                <Col md={7}>
                                    <div className='table-responsive'>
                                    <Table className="table   mb-0">
                                    <thead className="table-light">
                                    <tr>
                                    <th>Hospital</th>
                                    <th>2014/2022</th>
                                    <th>2022/2023</th>
                                    <th>2023/2024</th>
                                    {/* <th>2022/2023</th> */}
                                    <th>Total</th>
                                    <th>Percentage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.map((item, index) => (
                                    <tr key={index}>
                                        <td className="bold-column">{item.hospital}</td>
                                        <td>{item['2014/2022']}</td>
                                        <td>{item['2022/2023']}</td>
                                        <td>{item['2023/2024']}</td>
                                        {/* <td>{item['2022/2023']}</td> */}
                                        <td>{item.Total}</td>
                                        <td>{item.Percentage}</td>
                                    </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th className="bold-column">Total</th>
                                        <td className="bold-column">{calculateColumnTotal('2014/2022')}</td>
                                        <td className="bold-column">{calculateColumnTotal('2022/2023')}</td>
                                        <td className="bold-column">{calculateColumnTotal('2023/2024')}</td>
                                        {/* <td className="bold-column">{calculateColumnTotal('2022/2023')}</td> */}
                                        <td className="bold-column">{calculateColumnTotal('Total')}</td>
                                        <td className="bold-column">{calculateColumnTotal('Percentage')}</td>
                                    </tr>
                                    </tfoot>
                                    </Table>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <Apaexlinecolumn dataColors='["--bs-danger","--bs-primary", "--bs-success", "--bs-info" ]'/>
                                </Col>
                            </Row>

                        </Col>
                        {/* <Col  md={1}/> */}
                    </Row>
                    <Label className='simple-content' >96% of our beneficiaries have undergone surgery at the Sri Jayawardenapura General Hospital (SJGH) which is a fee levying semi government hospital where the cost of a surgery is on average 40-50% lower than what it would cost at a fully private hospital. The SJGH provides a very interesting model to take the load off the huge demand for heart surgeries and its attendant waiting period (1-2 years) encountered at the non-fee-levying state hospitals that undertake heart surgeries.</Label>

                </Container>
            </div>
        </div>
    );
}

export default hospitalBreakdown;


